import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Upload, Row, Col, Form, Input } from "antd";
import Resizer from "react-image-file-resizer";

const RegisterLogo = (props) => {
  // -------------------------- VAR --------------------------
  const logo = props?.logo || "";
  const disabled = props?.disabled || false;
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUpload = (action) => {
    const file = action.file;
    setLoading(true);
    Resizer.imageFileResizer(
      file,
      512,
      512,
      "jpg",
      96,
      0,
      (uri) => {
        setLoading(false);
        props.onSelect(uri);
      },
      "base64"
    );
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  const renderLogo = () => {
    return (
      <img
        src={logo}
        alt="logo"
        style={{
          width: "100%",
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Logo</div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row
      gutter={[16, 16]}
      justify="center"
      align="center"
      style={{ marginBottom: 10 }}
    >
      <Col>
        <Upload
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          disabled={disabled || loading}
          beforeUpload={beforeUpload}
          customRequest={handleUpload}
        >
          {logo ? renderLogo() : renderButton()}
        </Upload>
        <Form.Item name="logo">
          <Input hidden={true} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default RegisterLogo;
